import { expected } from '@aloft/toolkit-shared';

import { useParams } from 'react-router';

import { ModuleContainer } from '../../layout/ModuleContainer.tsx';
import { AdjustmentsGridModule } from '../../modules/adjustmentsGrid/AdjustmentsGridModule.tsx';
import { PropertyComparisonGridSyncDriver } from '../craftsmanOrderSync/PropertyComparisonGridSyncDriver.tsx';

export const AdjustmentsGridRouteElement = () => {
  const orderId = expected(useParams().orderId);

  return (
    <PropertyComparisonGridSyncDriver orderID={orderId}>
      <ModuleContainer moduleID="adjustmentsGrid" compact>
        <AdjustmentsGridModule />
      </ModuleContainer>
    </PropertyComparisonGridSyncDriver>
  );
};
